import myInterface from './myInterface';

// this is not a interface function, it is just for checking if method exist in interface
/**
 * @return {*}
 * @param {*} interfaceName
 */
const checkIfInterfaceExist = (interfaceName) => {
  if (myInterface[interfaceName]) {
    return true;
  }
  return false;
};

export default checkIfInterfaceExist;
